import { Particle, type ParticleOptions } from "../Particle";
import { MovesUp } from "../behaviors/MovesUp";
import { Lifetime } from "../behaviors/Lifetime";
import { adjustColor } from "../../utils/color";

export class Steam extends Particle {
    static baseColor = 0xE6F7FF; // Very pale blue-ish white

    constructor(options: Partial<ParticleOptions> = {}) {
        super({
            name: "Steam",
            color: adjustColor(Steam.baseColor, 5),
            behaviors: [
                new MovesUp(),
                new Lifetime(10, 30)
            ],
            temperature: 100,
            minTemp: 20,
            maxTemp: 1000,
            ...options
        });
    }
}
